import BackendService from './BackendService';

async function getItemAddonMappings() {
  return BackendService.getData('/items/addon-mappings/');
}
async function createItemAddonMappings(id, data) {
  return BackendService.postData(`/items/${id}/addon-mapping/batch/`, data);
}
async function updateItemAddonMappings(id, data) {
  return BackendService.patch(`/items/${id}/addon-mapping/batch/`, data);
}

const ItemAddonService = {
  getItemAddonMappings,
  createItemAddonMappings,
  updateItemAddonMappings,
};

export default ItemAddonService;
